import moment from "moment";

type TMomentRange = [moment.Moment, moment.Moment];

export function formatDateTime(
  dateTimeString: string,
  format: string = "YYYY-MM-DD HH:mm:ss"
) {
  return moment(dateTimeString).format(format);
}

export function getDateTimeRangeByHours(hours: number): TMomentRange {
  const end = moment();
  const start = moment(end).subtract(hours, "hours");

  return [start, end];
}

export function getDayjsRangeByHours(hours: number): TMomentRange {
  const end = moment();
  const start = moment(end).subtract(hours, "h");

  return [start, end];
}
